module.exports = __webpack_public_path__ + "img/logo1 (31).306a493a.jpg";